import React from 'react';
import HallOfFame from 'models/battles/HallOfFame';
import images from 'assets/images';
import { Tile } from '../Tile';
import { FormattedMessage } from 'react-intl';

export type ChampionTileProps = {
	data: HallOfFame;
};

export const ChampionTile = ({ data }: ChampionTileProps) => {
	const currentData = data.players.undefeatedChampion;

	if (!currentData) {
		return null;
	}

	return (
		<Tile
			title={<FormattedMessage id={`battle-hof.type.champion.title`} />}
			dateFrom={data.dateFrom}
			dateTo={data.dateTo}
			playerAvatar={currentData.avatar}
			playerName={currentData.fullname}
			icon={images.battles.battlesChampion}
			text={
				<FormattedMessage
					id={`battle-hof.type.champion.text`}
					values={{ value: Number(currentData.winRation) * 100 }}
				/>
			}
		/>
	);
};
